import React from "react";
import SiviElSabunuMavi from "../Components/product/SiviElSabunuMavi";
import PageHeader from "../Components/common/PageHeader";
import ProductSEO from "../Components/common/ProductSEO";
import { t } from "i18next";

function SiviElSabunuMaviPage() {
  return (
    <>
      <ProductSEO
        name="Sıvı El Sabunu (Mavi)"
        description="Ferahlık veren mavi serisi ile etkili temizlik ve hoş koku."
        slug="sivielsabunumavi"
        imagePath="assets/images/20-kg/11.webp"
      />
      <PageHeader title={t("SIVI EL SABUNU MAVİ")} />
      <SiviElSabunuMavi />
    </>
  );
}

export default SiviElSabunuMaviPage;